import React from "react"
import { HelmetProvider } from "react-helmet-async"
import Footer from "./components/Footer"
import Navbar from "./components/Navbar"
import Routes from "./Routes"
import ScrollToTop from "./utils/ScrollToTop"

const App = () => {
  return (
    <>
      <HelmetProvider>
        <ScrollToTop />
        <Navbar />
        <div className="container mt-5 mb-5 min-vh-100">
          <Routes />
        </div>
        <Footer />
      </HelmetProvider>
    </>
  )
}

export default App
